import './adjustments.css'
import React, {Fragment} from 'react'

export default function DisplayRow({children, className, rowSpan}){
	return<> 
		<div className={"mst-row " + className} rowSpan={rowSpan}>
			{children}
		</div>
	</>
}